import Title from './Title.vue'

type Themes = 'default' | 'huge' | 'big' | 'medium' | 'modal' | 'centered'

export interface Props {
  theme?: Themes | Array<Themes>
  type?: 'h1' | 'h2' | 'h3' | 'h4' | 'div' | 'span'
}

export default Title;